import { render, staticRenderFns } from "./issueBackflush.vue?vue&type=template&id=349662e3&"
import script from "./issueBackflush.vue?vue&type=script&lang=js&"
export * from "./issueBackflush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports